import React from "react";
import { useT } from "@/i18n/useT";

export default function ShippingPage() {
  const t = useT();
  const s = t.shipping;
  return (
    <div data-testid="shipping-page" className="br-container py-20 md:py-28 max-w-3xl space-y-16">
      <header className="br-fade-in">
        <div className="br-eyebrow mb-4">{s.eyebrow}</div>
        <h1 className="font-serif text-4xl md:text-6xl text-espresso leading-tight">{s.title}</h1>
      </header>
      {s.sections.map((sec, i) => (
        <section key={i} className="space-y-4">
          <h2 className="font-serif text-2xl md:text-3xl text-espresso">{sec.title}</h2>
          <p className="text-base font-light text-dark-walnut leading-relaxed">{sec.body}</p>
        </section>
      ))}
    </div>
  );
}